export enum searchDialogTypeEnum {
  CONTENT = '0',
  PHONE = '1',
}

export enum IsReadEnum {
  READ = 0,
  UNREAD = 1,
}

export enum RecordTypeEnum {
  TEXT = 0,
  FILE = 1,
  IMAGE = 2,
  VIDEO = 3,
  VOICE = 4,
}
